export const translationOrganizations_da_part3 = {
  orgDetailDeleteOrganizationNoChatbots: "ingen",
  orgDetailDeleteOrganizationConfirm: "Slet organisation",
  orgDetailUnableToDeleteOrganization: "Kunne ikke slette organisationen.",
  orgDetailInviteRedirectUrlLabel: "Omdirigerings-URL for invitationer",
  orgDetailInviteRedirectUrlHelp:
    "Brugere omdirigeres hertil, når de har accepteret en invitation eller fuldført registreringen. Brug en godkendt HTTPS-dashboard-URL. Lad feltet stå tomt for at rydde det. Invitationer forbliver blokeret, indtil der igen er angivet en gyldig URL.",
  orgDetailNameLabel: "Navn",
  orgDetailDomainsLabel: "Domæner",
  orgDetailDomainsPlaceholder: "acme.com, help.acme.com",
  orgDetailKnowledgeBaseIndexesLabel: "Vidensbase-indexes",
  orgDetailKnowledgeBaseIndexesHelp:
    "Angiv et JSON-array. Hver post skal have `namespace` og `index_name`. `group` er valgfri.",
  orgDetailCompanyInfoLabel: "Virksomhedsinfo",
  orgDetailAgentNameLabel: "Agentnavn",
  orgDetailProductButtonTextLabel: "Tekst på produktknap",
  orgDetailThumbsRating: "Tommelfinger-vurdering",
  orgDetailLivechat: "Livechat",
  orgDetailIntegrations: "Integrationer",
  orgDetailUseBrandScope: "Brug brand-scope (internt)",
  orgDetailLivechatNotificationSound: "Notifikationslyd for livechat",
  orgDetailSaveSettings: "Gem indstillinger",
  orgDetailAssignedChatbots: "Tilknyttede chatbots",
  orgDetailAssignedChatbotsDescription:
    "Disse chatbot-ID'er tilhører allerede denne organisation. Oprettelse og kloning findes under fanen Chatbots i Organisations-visningen.",
  orgDetailNoChatbotsAssigned: "Ingen chatbots tilknyttet",
  orgDetailAssignedExclusivelyTo: "Tilknyttet eksklusivt til {organization}",
  orgDetailAvailableToAttach: "Tilgængelige for tilknytning",
  orgDetailAvailableToAttachDescription:
    "Kun chatbot-ID'er uden tilknytning kan tilknyttes her. Chatbots, der er tilknyttet en anden organisation, er bevidst skjult.",
  orgDetailNoUnassignedChatbots:
    "Der er ingen chatbot-ID'er uden tilknytning. Opret et fra siden Chatbot-ID'er, eller fjern først en eksisterende tilknytning.",
  // Brands section (OrganizationBrandsSection.tsx)
  // Brands section (OrganizationBrandsSection.tsx)
  brandsUnableToLoad: "Kunne ikke indlæse brands.",
  brandsCreated: "Brand oprettet",
  brandsCouldNotCreate: "Kunne ikke oprette brand.",
  brandsNameCannotBeEmpty: "Navnet må ikke være tomt.",
  brandsRenamed: "Brand omdøbt",
  brandsCouldNotRename: "Kunne ikke omdøbe brand.",
  brandsDeleted: "Brand slettet",
  brandsCouldNotDelete: "Kunne ikke slette brand.",
  brandsSaved: "Gemt",
  brandsCouldNotUpdateChatbot: "Kunne ikke opdatere chatbot.",
  brandsTitle: "Brands",
  brandsIntro:
    "Gruppér chatbots i denne organisation i brands. Brugere ser brands i scope-vælgeren, når brand-scope er slået til for organisationen.",
  brandsListTitle: "Brandliste",
  brandsTotalCount: "{count} i alt",
  brandsNewBrandNamePlaceholder: "Navn på nyt brand",
  brandsNoBrandsYet: "Ingen brands endnu",
  brandsRenameName: "Omdøb {name}",
  brandsDeleteName: "Slet {name}",
  brandsChatbotAssignmentsTitle: "Chatbot-tilknytninger",
  brandsNoChatbotsInOrganization: "Ingen chatbots i denne organisation",
  brandsSelectBrandPlaceholder: "Vælg brand",
  brandsUngrouped: "Ikke grupperet",
  brandsDeleteConfirmTitle: "Slet dette brand?",
  brandsDeleteConfirmDescription: "Chatbots i dette brand vil ikke længere være grupperet.",
  orgTypeTitle: "Kundetype",
  orgTypeDescription:
    "Hvad kunden sælger eller laver. Produktanalyse grupperer og sammenligner kunder efter den. Kun Diverge-administratorer; kunder ser den aldrig.",
  orgTypeMain: "Hovedtype",
  orgTypeExtra: "Ekstra typer",
  orgTypeExtraHelp:
    "Alt andet kunden sælger eller laver, fx skønhed i et modevarehus. Kun filtre bruger dem.",
  orgTypeNone: "Ingen type endnu",
  orgTypeGroupShops: "Webshops",
  orgTypeGroupOther: "Ikke en webshop",
  orgTypeGroupExcluded: "Udeladt af analyser",
  orgTypePickMainFirst: "Vælg først en hovedtype",
  orgTypeNoExtra: "Ingen",
  orgTypeSearch: "Find en type",
  orgTypeNoMatch: "Ingen type med det navn",
  orgTypeInGroup: "I analysegruppen",
  orgTypeMessages: "{count} beskeder fra besøgende de seneste 30 dage",
  orgTypeLastChange: "Ændret {date} af {who}",
  orgTypeFromList: "den gennemgåede liste",
  orgTypeNotListed:
    "Denne organisation har endnu ingen post på platformen, så den kan ikke få en type.",
  orgTypeLoadError: "Kunne ikke indlæse kundetyperne.",
  orgTypeSaveError: "Kunne ikke gemme kundetyperne. Prøv igen om lidt.",
  orgTypeRetry: "Prøv igen",
  // Language routing (Organizations/languageRouting)
  orgDetailLanguageRoutingTitle: "Routing efter sprog",
  orgDetailLanguageRoutingDescription:
    "Indlæs en anden chatbot for hvert sidesprog. Scriptet læser sidens lang-attribut og indlæser den chatbot, der er knyttet til sproget. Sider på alle andre sprog indlæser hovedchatbotten.",
  orgDetailLanguageRoutingLoadError: "Kunne ikke indlæse sprogruterne.",
  orgDetailLanguageRoutingRetry: "Prøv igen",
  orgDetailLanguageRoutingCurrentTitle: "Nuværende ruter",
  orgDetailLanguageRoutingNoRoutes: "Ingen chatbot i denne organisation har sprogruter endnu.",
  orgDetailLanguageRoutingColumnMain: "Hovedchatbot",
  orgDetailLanguageRoutingColumnLanguage: "Sprog",
  orgDetailLanguageRoutingColumnTarget: "Indlæser chatbot",
  orgDetailLanguageRoutingNeedsTwoChatbots:
    "Routing efter sprog kræver mindst to chatbots i denne organisation. Tilknyt en chatbot mere for at sætte det op.",
  orgDetailLanguageRoutingMainLabel: "Hovedchatbot",
  orgDetailLanguageRoutingMainPlaceholder: "Vælg hovedchatbotten",
  orgDetailLanguageRoutingMainHelp: "Den chatbot, hvis script ligger på kundens side.",
  orgDetailLanguageRoutingRoutesLegend: "Sprog for {chatbotId}",
  orgDetailLanguageRoutingNoRows:
    "Ingen sprog har en rute endnu, så alle sider indlæser denne chatbot.",
  orgDetailLanguageRoutingLanguageLabel: "Sprogkode",
  orgDetailLanguageRoutingLanguagePlaceholder: "sv",
  orgDetailLanguageRoutingTargetLabel: "Chatbot der indlæses",
  orgDetailLanguageRoutingTargetPlaceholder: "Vælg en chatbot",
  orgDetailLanguageRoutingRemoveRoute: "Fjern ruten for {language}",
  orgDetailLanguageRoutingRemoveEmptyRoute: "Fjern rute {number}",
  orgDetailLanguageRoutingAddLanguage: "Tilføj sprog",
  orgDetailLanguageRoutingSave: "Gem ruter",
  orgDetailLanguageRoutingSaving: "Gemmer ruter",
  orgDetailLanguageRoutingInvalidLanguage:
    "Brug en sprogkode på to eller tre bogstaver, fx sv eller de.",
  orgDetailLanguageRoutingDuplicateLanguage: "Dette sprog har allerede en rute.",
  orgDetailLanguageRoutingTargetRequired: "Vælg den chatbot, der skal indlæses for dette sprog.",
  orgDetailLanguageRoutingFixErrors: "Ret de markerede ruter, og gem igen.",
  orgDetailLanguageRoutingSaved: "Sprogruter gemt for {chatbotId}.",
  orgDetailLanguageRoutingSaveError: "Kunne ikke gemme sprogruterne.",
  orgDetailLanguageRoutingTargetUnavailable:
    "En chatbot, der skal indlæses, hører ikke længere til denne organisation. Genindlæs siden, og vælg igen.",
  orgDetailLanguageRoutingTooManyRoutes: "En chatbot kan højst have 100 sprog.",
  orgDetailLanguageRoutingMainUnavailable:
    "Hovedchatbotten hører ikke længere til denne organisation. Genindlæs siden.",
  orgDetailLanguageRoutingSnippetTitle: "Script til kundens side",
  orgDetailLanguageRoutingSnippetHelp:
    "Routing kører kun, når hovedchatbottens script har {parameter}. Udskift hovedchatbottens nuværende script med dette på alle sider.",
};
